import { Flex } from '@atlaskit/primitives';
import type { FunctionComponent } from 'react';
import Headline from './Headline';
import PermissionsBullets from './PermissionsBullets';
import LegalDisclaimer from './LegalDisclaimer';
import Description from './Description';

const Bitbucket: FunctionComponent = () => {
  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Headline />
      <Description />
      <PermissionsBullets />
      <LegalDisclaimer />
    </Flex>
  );
};

export default Bitbucket;
